import _ from "lodash";
import { useI18n } from "Hooks";
import { connect } from "react-redux";
import React, { useState, useCallback } from "react";
import { IconButton, Tooltip } from "@toddle-edu/ds-web";
import {
  AttachmentClipOutlined,
  DeviceDesktopOutlined,
  GoogleDriveColored,
  LinkOutlined,
  OneDriveColored,
} from "@toddle-edu/ds-icons";

import { CreateDropDown } from "Attachment";
import client from "lib/apolloClient/client";
import { ATTACHMENT_OMIT_ATTRIBUTES } from "store/static";
import { createAttachmentsMutation } from "Worksheet/modules/WorksheetMutations";
import { ALLOWED_FILE_TYPES } from "AppComponents/AIContextBar/modules/Constants";

const CREATE_DROPDOWN_OPTIONS = [
  {
    key: "upload_device",
    label: "common:upload_device",
    icon: <DeviceDesktopOutlined size={"xx-small"} />,
  },
  {
    key: "add_link",
    label: "common:add_link",
    icon: <LinkOutlined size={"xx-small"} />,
  },
  {
    key: "add_google_drive",
    label: "common:add_google_drive",
    icon: <GoogleDriveColored size={"xx-small"} />,
  },
  {
    key: "add_one_drive",
    label: "common:add_one_drive",
    icon: <OneDriveColored size={"xx-small"} />,
  },
];

const AIPanelContextBarAttachment = props => {
  const { t } = useI18n();
  const [isCreateDropdownVisible, setIsCreateDropdownVisible] = useState(false);

  const {
    onUpload,
    conversationId,
    isDisabled = false,
    isAttachmentUploading = false,
    testId = "ai-panel-context-bar-attachment",
  } = props;

  const onContentUploaded = useCallback(
    async attachments => {
      setIsCreateDropdownVisible(false);

      if (_.isEmpty(attachments)) return;

      await client.mutate({
        mutation: createAttachmentsMutation,
        variables: {
          input: _.map(attachments, newFile => ({
            ..._.omit(newFile, ["id", ...ATTACHMENT_OMIT_ATTRIBUTES]),
            parentId: conversationId,
            parentType: "AI_CONVERSATION",
          })),
        },
        update: (
          cache,
          {
            data: {
              platform: { createAttachment },
            },
          }
        ) => {
          if (_.isFunction(onUpload)) onUpload(createAttachment);
        },
      });
    },
    [onUpload]
  );

  return (
    <CreateDropDown
      mode={"edit"}
      testId={testId}
      dsVersion={"2.0"}
      exportAsPdf={true}
      multiselect={true}
      isNewDropdown={true}
      showDisplayText={false}
      enableShareModal={false}
      parentId={conversationId}
      accept={ALLOWED_FILE_TYPES}
      parentType={"AI_CONVERSATION"}
      visible={isCreateDropdownVisible}
      onMultipleFilesUploaded={onContentUploaded}
      disabled={isDisabled || isAttachmentUploading}
      dropDownOptions={CREATE_DROPDOWN_OPTIONS}
      onVisibleChange={setIsCreateDropdownVisible}
      buttonComponent={
        <Tooltip tooltip={t("ai:attach")} showArrow={true}>
          <IconButton
            icon={<AttachmentClipOutlined />}
            type={"plain"}
            variant={"neutral"}
            size={"medium"}
            disabled={isDisabled || isAttachmentUploading}
            testId={testId}
            dsVersion={"2.0"}
          />
        </Tooltip>
      }
    />
  );
};

const mapStateToProps = (state, ownProps) => {
  const { conversationId } = ownProps;
  const progressOfUploads = _.get(state, "app_services.progressOfUploads", {});

  const isAttachmentUploading = _.some(_.keys(progressOfUploads), key => {
    const { parentId, parentType } = progressOfUploads[key] || {};
    return parentId === conversationId && parentType === "AI_CONVERSATION";
  });

  return {
    isAttachmentUploading,
  };
};

export default connect(mapStateToProps, null)(AIPanelContextBarAttachment);
